























import { Component, Vue, Watch, Inject, Prop } from 'vue-property-decorator';
@Component({})
export default class EmoticonDiplay extends Vue {
  @Prop() public value!: number;
  @Prop({ default: 'nps' }) public indicator!: string;
  @Prop() public whiteMode!: boolean;
}
